import React from "react";
import Weather from "./Weather";
import "./App.css";

export default function App() {
  return (
    <div className="App">
      <div className="container">
        <Weather defaultCity="New York" />

        <footer>
          <a
            href="https://github.com/gelvht/shecodes"
            target="_blank"
            rel="noopener noreferrer"
          >
            github link
          </a>
        </footer>
      </div>
    </div>
  );
}
